import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import {
  BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS,
  BUILDING_GROUP_FORM_FIELD_NAME_UPDATE_MANAGERS,
} from '../../../BuildingGroupForm.constants'

export function useResetUpdateManagerCheckbox() {
  const { setFieldValue, values } = useFormikContext()

  useEffect(() => {
    if (values[BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS]?.length === 0) {
      setFieldValue(BUILDING_GROUP_FORM_FIELD_NAME_UPDATE_MANAGERS, false)
    }
  }, [values[BUILDING_GROUP_FORM_FIELD_NAME_MANAGERS]])
}
